fx.ns("desktop.print", class PrintPhotoChoices extends desktop.common.photoimport.PhotoChoices {

	constructor() {
		super();

		this.showNext = false;
		this.effect = "vslidein";
	}

	get defaults() {
		return { computer: true, mobile: true, facebook: false, google: true, instagram: false, file: false, albums: false }
	}

});